export default __webpack_public_path__ + "static/media/Project Stages-bro.97c18b17.svg";